export const CAMERA = {
    /** Distance the camera trails behind the cat. */
    distance: 8,
    /** Height of the point the camera looks at, above the cat's feet. */
    targetHeight: 1.2,
    /** Vertical angle limits in radians — kept away from the poles. */
    minPitch: -0.5,
    maxPitch: 1.1,
    /** Fraction of the remaining gap the camera closes per second. */
    followRate: 10,
    mouseSensitivity: 0.0025,
    /** Fraction of the remaining angle the cat turns per second. */
    turnRate: 12,
};
//# sourceMappingURL=camera.js.map